import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { SetupWizardPayload, SetupWizardSteps } from '@mira-avant/mtlibs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';

@Component({
	selector: 'app-setup-wizard-preview-stats',
	imports: [CommonModule, NzStatisticModule, NzIconModule],
	templateUrl: './setup-wizard-preview-stats.html',
	styleUrl: './setup-wizard-preview-stats.scss',
})
export class SetupWizardPreviewStats {
	public preview = input<SetupWizardPayload | undefined>();
	public steps = input<SetupWizardSteps[]>();
	public SetupWizardSteps = SetupWizardSteps;

	ngOnInit() {
		console.log('Preview Stats:', this.preview());
	}
}
